import React, { useEffect, useState } from "react";
import Input from "../../../components/Input";
import InputCheckboxUnique from "../../../components/InputCheckboxUnique";
import InputEditorTiny from "../../../components/InputEditorTiny";
import InputSelect from "../../../components/InputSelect";
import InputTextarea from "../../../components/InputTextarea";
import { convertIntToMoney } from "../../../helpers/conversions";
import { createOptions } from "../../../helpers/selects";
import api from "../../../services/api";
import { hasPermission } from "../../../services/auth";
import PaymentConditionFields from "../../../components/PaymentCondition";
import states from "../../../seeds/states";

const paymentStatusOptions = [
    { label: 'Quitado', value: 'quitado' },
    { label: 'Parcialmente quitado', value: 'parcialmente-quitado' },
    { label: 'Não quitado', value: 'nao-quitado' }
];

const faturadoOptions = [
    { label: 'Faturado', value: 'faturado' },
    { label: 'Não faturado', value: 'nao-faturado' }
];

const shippingTypeOptions = [
    {label: 'Não informado', value: null},
    {label: 'CIF', value: 'CIF'},
    {label: 'FOB', value: 'FOB'}
];

const OrderDetailTab = ({
    order,
    fiscalFieldErrors,
    selectedStatus, 
    setSelectedStatus,
    selectedPagamentoStatus,
    setSelectedPagamentoStatus,
    selectedFaturadoStatus,
    setSelectedFaturadoStatus,
    financeComments,
    setFinanceComments,
    shippingTypeReal,
    setShippingTypeReal,
    shippingFeeReal,
    setShippingFeeReal,
    shippingTimeReal,
    setShippingTimeReal,
    shippingTime,
    setShippingTime,
    paymentTermReal,
    setPaymentTermReal,
    paymentFormReal,
    setPaymentFormReal,
    billingCompanyCnpjReal,
    setBillingCompanyCnpjReal,
    shippingTypeConference,
    setShippingTypeConference,
    shippingFeeConference,
    setShippingFeeConference,
    shippingTimeConference,
    setShippingTimeConference,
    paymentTermConference,
    setPaymentTermConference,
    paymentFormConference,
    setPaymentFormConference,
    billingCompanyCnpjConference,
    setBillingCompanyCnpjConference,
    customerCompanyCnpj,
    setCustomerCompanyCnpj,
    customerCompanyCompanyName,
    setCustomerCompanyCompanyName,
    customerCompanyTradeName,
    setCustomerCompanyTradeName,
    customerCpf,
    setCustomerCpf,
    customerName,
    setCustomerName,
    customerEmail,
    setCustomerEmail,
    customerPhone,
    setCustomerPhone,
    billingCompanyCnpj,
    setBillingCompanyCnpj,
    billingCompanyCompanyName,
    setBillingCompanyCompanyName,
    billingCompanyTradeName,
    setBillingCompanyTradeName,
    shippingRecipientName,
    setShippingRecipientName,
    shippingCompanyName,
    setShippingCompanyName,
    shippingZipCode,
    setShippingZipCode,
    shippingStreet,
    setShippingStreet,
    shippingNumber,
    setShippingNumber,
    shippingComplement,
    setShippingComplement,
    shippingDistrict,
    setShippingDistrict,
    shippingCity,
    setShippingCity,
    shippingState,
    setShippingState,
    billingZipCode,
    setBillingZipCode,
    billingStreet,
    setBillingStreet,
    billingNumber,
    setBillingNumber,
    billingComplement,
    setBillingComplement,
    billingDistrict,
    setBillingDistrict,
    billingCity,
    setBillingCity,
    billingState,
    setBillingState,
    clientZipCode,
    setClientZipCode,
    clientStreet,
    setClientStreet,
    clientNumber,
    setClientNumber,
    clientComplement,
    setClientComplement,
    clientDistrict,
    setClientDistrict,
    clientCity,
    setClientCity,
    clientState,
    setClientState,
    payment,
    setPayment,
    comments,
    setComments
}) => {
    const [statuses, setStatuses] = useState([]);

    useEffect(() => {
        getStatuses();
    }, []);

    const getStatuses = () => {
        api.get(`/status?filters[0][type][equal]=order`).then(res => {
            setStatuses(res.data.resources);
        });
    }

    const setOriginalShippingType = e => {
        e.preventDefault();
        setShippingTypeReal(order.shipping_type);
    }

    const setOriginalShippingFee = e => {
        e.preventDefault();
        let fee = order.shipping_consult ? 'R$ 0,00' : convertIntToMoney(order.shipping_fee, true);
        setShippingFeeReal(fee);
    }

    const setOriginalShippingTime = e => {
        e.preventDefault();
        setShippingTimeReal(order.shipping_time);
    }

    const setOriginalPaymentTerm = e => {
        e.preventDefault();
        setPaymentTermReal(order.payment_term);
    }

    const setOriginalPaymentForm = e => {
        e.preventDefault();
        setPaymentFormReal(order.payment_form);
    }

    /**
     * A marcação vale enquanto o campo continuar com o valor que reprovou na
     * checagem. Mexeu — à mão ou pelo endereço que o CEP trouxe — o erro sai,
     * sem ida ao backend.
     */
    const fiscalError = (field, value) => {
        const error = (fiscalFieldErrors ?? {})[field];

        if (!error) return undefined;

        return (value ?? '') === (error.at ?? '') ? error.message : undefined;
    };

    const setOriginalBillingCompanyCnpj = e => {
        e.preventDefault();
        setBillingCompanyCnpjReal(order.billing_company_cnpj);
    }

    return (
        <>
            <div className="row">
                <div className="col-3">
                    <Input label={`Código do pedido`} value={order?.code} disabled={true} />
                </div>
                <div className="col-3">
                    <Input label={`Pedido do cliente`} value={order?.customer_purchase_order} disabled={true} />
                </div>
                <div className="col-3">
                    <Input label={`Responsável`} value={order?.admin_name} disabled={true} />
                </div>
                <div className="col-3">
                    <InputSelect
                        label={`Status do pedido`}
                        options={createOptions(statuses, 'name', 'id')}
                        value={selectedStatus}
                        change={setSelectedStatus}
                    />
                </div>
            </div>
            <h2 className="section-title">Cliente</h2>
            <div className="row">
                <div className="col-3">
                    <Input label={`Nome da pessoa`} value={customerName} change={setCustomerName} />
                </div>
                <div className="col-3">
                    <Input label={`E-mail`} value={customerEmail} change={setCustomerEmail} type={`email`} />
                </div>
                <div className="col-3">
                    <Input label={`Telefone`} value={customerPhone} change={setCustomerPhone} mask={`convertToPhone`} />
                </div>
                <div className="col-3">
                    <Input label={`CPF`} value={customerCpf} change={setCustomerCpf} mask={`convertToCpf`} error={fiscalError('customer_cpf', customerCpf)} />
                </div>
            </div>
            {order?.type === "PJ" &&
                <div className="row">
                    <div className="col-3">
                        <Input label={`CNPJ`} value={customerCompanyCnpj} change={setCustomerCompanyCnpj} mask={`convertToCnpj`} error={fiscalError('customer_company_cnpj', customerCompanyCnpj)} />
                    </div>
                    <div className="col-4">
                        <Input label={`Razão social`} value={customerCompanyCompanyName} change={setCustomerCompanyCompanyName} />
                    </div>
                    <div className="col-4">
                        <Input label={`Nome da empresa`} value={customerCompanyTradeName} change={setCustomerCompanyTradeName} />
                    </div>
                </div>
            }
            <h2 className="section-title">Endereço do cliente</h2>
            <div className="row">
                <div className="col-2">
                    <Input label={`CEP`} value={clientZipCode} change={setClientZipCode} mask={`convertToCep`} error={fiscalError('zip_code', clientZipCode)} />
                </div>
                <div className="col-5">
                    <Input label={`Rua`} value={clientStreet} change={setClientStreet} />
                </div>
                <div className="col-2">
                    <Input label={`Número`} value={clientNumber} change={setClientNumber} error={fiscalError('number', clientNumber)} />
                </div>
                <div className="col-3">
                    <Input label={`Complemento`} value={clientComplement} change={setClientComplement} />
                </div>
            </div>
            <div className="row">
                <div className="col-3">
                    <Input label={`Bairro`} value={clientDistrict} change={setClientDistrict} error={fiscalError('district', clientDistrict)} />
                </div>
                <div className="col-4">
                    <Input label={`Cidade`} value={clientCity} change={setClientCity} error={fiscalError('city', clientCity)} />
                </div>
                <div className="col-2">
                    <InputSelect label={`Estado`} options={states} value={clientState} change={setClientState} error={fiscalError('state', clientState)} menuInBody={true} />
                </div>
            </div>
            <h2 className="section-title">Empresa de faturamento</h2>
            <div className="row">
                <div className="col-3">
                    <Input label={`CNPJ`} value={billingCompanyCnpj} change={setBillingCompanyCnpj} mask={`convertToCnpj`} />
                </div>
                <div className="col-4">
                    <Input label={`Razão social`} value={billingCompanyCompanyName} change={setBillingCompanyCompanyName} />
                </div>
                <div className="col-4">
                    <Input label={`Nome da empresa`} value={billingCompanyTradeName} change={setBillingCompanyTradeName} />
                </div>
            </div>
            <h2 className="section-title">Pagamento</h2>
            <div className="row">
                <PaymentConditionFields
                    value={payment}
                    change={setPayment}
                    termClassName={`col-6`}
                    methodClassName={`col-6`}
                />
            </div>
            <h2 className="section-title">Observações</h2>
            <div className="row">
                <div className="col-12">
                    <InputEditorTiny
                        label={`Comentários / Observações`}
                        value={comments}
                        change={setComments}
                    />
                </div>
            </div>
            <h2 className="section-title">Entrega</h2>
            <div className="row">
                <div className="col-3">
                    <Input label={`Prazo de entrega`} value={shippingTime} change={setShippingTime} />
                </div>
                <div className="col-4">
                    <Input label={`Transportadora`} value={shippingCompanyName} change={setShippingCompanyName} placeholder={`Nome da transportadora`} />
                </div>
                <div className="col-4">
                    <Input label={`Quem irá receber`} value={shippingRecipientName} change={setShippingRecipientName} placeholder={`Nome de quem irá receber o pedido`} />
                </div>
            </div>
            <h2 className="section-title">Endereço de entrega</h2>
            <div className="row">
                <div className="col-2">
                    <Input label={`CEP`} value={shippingZipCode} change={setShippingZipCode} mask={`convertToCep`} />
                </div>
                <div className="col-5">
                    <Input label={`Rua`} value={shippingStreet} change={setShippingStreet} />
                </div>
                <div className="col-2">
                    <Input label={`Número`} value={shippingNumber} change={setShippingNumber} />
                </div>
                <div className="col-3">
                    <Input label={`Complemento`} value={shippingComplement} change={setShippingComplement} />
                </div>
            </div>
            <div className="row">
                <div className="col-3">
                    <Input label={`Bairro`} value={shippingDistrict} change={setShippingDistrict} />
                </div>
                <div className="col-4">
                    <Input label={`Cidade`} value={shippingCity} change={setShippingCity} />
                </div>
                <div className="col-2">
                    <InputSelect label={`Estado`} options={states} value={shippingState} change={setShippingState} menuInBody={true} />
                </div>
            </div>
            <h2 className="section-title">Endereço de cobrança</h2>
            <div className="row">
                <div className="col-2">
                    <Input label={`CEP`} value={billingZipCode} change={setBillingZipCode} mask={`convertToCep`} />
                </div>
                <div className="col-5">
                    <Input label={`Rua`} value={billingStreet} change={setBillingStreet} />
                </div>
                <div className="col-2">
                    <Input label={`Número`} value={billingNumber} change={setBillingNumber} />
                </div>
                <div className="col-3">
                    <Input label={`Complemento`} value={billingComplement} change={setBillingComplement} />
                </div>
            </div>
            <div className="row">
                <div className="col-3">
                    <Input label={`Bairro`} value={billingDistrict} change={setBillingDistrict} />
                </div>
                <div className="col-4">
                    <Input label={`Cidade`} value={billingCity} change={setBillingCity} />
                </div>
                <div className="col-2">
                    <InputSelect label={`Estado`} options={states} value={billingState} change={setBillingState} menuInBody={true} />
                </div>
            </div>
            <h2 className="section-title">Total</h2>
            <div className="row">
                <div className="col-3">
                    <Input label={`Total`} value={`R$ ${convertIntToMoney(order?.total)}`} disabled={true} />
                </div>
            </div>
            {/* <div className="row">
                <div className="col-6">
                    <h2 className="section-title">Conferência</h2>
                    <div className="order-conference">
                        <div className="row">
                            <div className="col-4">
                                <Input label={`CNPJ do faturamento`} value={order?.billing_company_cnpj} disabled={true} />
                            </div>
                            <div className="col-5">
                                <div className="input-group-with-link">
                                    <Input label={`CNPJ do faturamento real`} 
                                        value={billingCompanyCnpjReal} 
                                        change={setBillingCompanyCnpjReal} 
                                        mask={`convertToCnpj`}
                                        disabled={!hasPermission('edit_conference')}
                                    />
                                    {hasPermission('edit_conference') &&
                                        <a href="#" onClick={setOriginalBillingCompanyCnpj}>Preencher com valor original</a>
                                    }
                                </div>
                            </div>
                            <div className="col-3">
                                {hasPermission('edit_conference') &&
                                    <InputCheckboxUnique label={'Conferido'} checked={billingCompanyCnpjConference} change={setBillingCompanyCnpjConference} />
                                }
                            </div>
                        </div>
                        <div className="row">
                            <div className="col-4">
                                <Input label={`Tipo do frete`} value={order?.shipping_type} disabled={true} />
                            </div>
                            <div className="col-5">
                                <div className="input-group-with-link">
                                    <InputSelect
                                        label={`Tipo do frete real`}
                                        options={shippingTypeOptions}
                                        value={shippingTypeReal}
                                        change={setShippingTypeReal}
                                        isDisabled={!hasPermission('edit_conference')}
                                    />
                                    {hasPermission('edit_conference') &&
                                        <a href="#" onClick={setOriginalShippingType}>Preencher com valor original</a>
                                    }
                                </div>
                            </div>
                            <div className="col-3">
                                {hasPermission('edit_conference') &&
                                    <InputCheckboxUnique label={'Conferido'} checked={shippingTypeConference} change={setShippingTypeConference} />
                                }
                            </div>
                        </div>
                        <div className="row">
                            <div className="col-4">
                                <Input label={`Valor do frete`} value={order?.shipping_consult === true ? 'A consultar' : convertIntToMoney(order?.shipping_fee, true)} disabled={true} />
                            </div>
                            <div className="col-5">
                                <div className="input-group-with-link">
                                    <Input label={`Valor do frete real`} 
                                        value={shippingFeeReal} 
                                        change={setShippingFeeReal} 
                                        mask={`convertToMoney`}
                                        disabled={!hasPermission('edit_conference')}
                                    />
                                    {hasPermission('edit_conference') &&
                                        <a href="#" onClick={setOriginalShippingFee}>Preencher com valor original</a>
                                    }
                                </div>
                            </div>
                            <div className="col-3">
                                {hasPermission('edit_conference') &&
                                    <InputCheckboxUnique label={'Conferido'} checked={shippingFeeConference} change={setShippingFeeConference} />
                                }
                            </div>
                        </div>
                        <div className="row">
                            <div className="col-4">
                                <Input label={`Prazo de entrega`} value={order?.shipping_time} disabled={true} />
                            </div>
                            <div className="col-5">
                                <div className="input-group-with-link">
                                    <Input 
                                        label={`Prazo de entrega real`} 
                                        value={shippingTimeReal} 
                                        change={setShippingTimeReal} 
                                        disabled={!hasPermission('edit_conference')}
                                    />
                                    {hasPermission('edit_conference') &&
                                        <a href="#" onClick={setOriginalShippingTime}>Preencher com valor original</a>
                                    }
                                </div>
                            </div>
                            <div className="col-3">
                                {hasPermission('edit_conference') &&
                                    <InputCheckboxUnique label={'Conferido'} checked={shippingTimeConference} change={setShippingTimeConference} />
                                }
                            </div>
                        </div>
                    </div>
                    <div className="order-conference">
                        <div className="row">
                            <div className="col-4">
                                <Input label={`Cond. de pagto.`} value={order?.payment_term} disabled={true} />
                            </div>
                            <div className="col-5">
                                <div className="input-group-with-link">
                                    <Input 
                                        label={`Cond. de pagto. real`} 
                                        value={paymentTermReal} 
                                        change={setPaymentTermReal} 
                                        disabled={!hasPermission('edit_conference')}
                                    />
                                    {hasPermission('edit_conference') &&
                                        <a href="#" onClick={setOriginalPaymentTerm}>Preencher com valor original</a>
                                    }
                                </div>
                            </div>
                            <div className="col-3">
                                {hasPermission('edit_conference') &&
                                    <InputCheckboxUnique label={'Conferido'} checked={paymentTermConference} change={setPaymentTermConference} />
                                }
                            </div>
                        </div>
                        <div className="row">
                            <div className="col-4">
                                <Input label={`Forma de pagto.`} value={order?.payment_form} disabled={true} />
                            </div>
                            <div className="col-5">
                                <div className="input-group-with-link">
                                    <Input 
                                        label={`Forma de pagto. real`} 
                                        value={paymentFormReal} 
                                        change={setPaymentFormReal}
                                        disabled={!hasPermission('edit_conference')}
                                    />
                                    {hasPermission('edit_conference') &&
                                        <a href="#" onClick={setOriginalPaymentForm}>Preencher com valor original</a>
                                    }
                                </div>
                            </div>
                            <div className="col-3">
                                {hasPermission('edit_conference') &&
                                    <InputCheckboxUnique label={'Conferido'} checked={paymentFormConference} change={setPaymentFormConference} />
                                }
                            </div>
                        </div>
                    </div>
                </div>
                <div className="col-6">
                    <h2 className="section-title">Financeiro</h2>
                    <div className="order-finance">
                        <div className="row">
                            <div className="col-6">
                                <InputSelect
                                    label={`Pedido quitado`}
                                    options={paymentStatusOptions}
                                    value={selectedPagamentoStatus}
                                    change={setSelectedPagamentoStatus}
                                />
                            </div>
                            <div className="col-6">
                                <InputSelect
                                    label={`Faturado`}
                                    options={faturadoOptions}
                                    value={selectedFaturadoStatus}
                                    change={setSelectedFaturadoStatus}
                                />
                            </div>
                        </div>
                        <div className="row">
                            <div className="col">
                                <InputEditorTiny
                                    label={`Observações`}
                                    value={financeComments}
                                    change={setFinanceComments}
                                />
                            </div>
                        </div>
                    </div>
                </div>
            </div> */}
            
        </>
    );
} 

export default OrderDetailTab;